import * as angular from "angular";

declare let heap:any;

function HeapProvider(): any {


  this.load = (appId) => {
    // heap.load(appId);
  };

  this.identify = (userId) => {
    // heap.identify(userId);
  };

  this.track = (eventName, properties?) => {
    // heap.track(eventName, properties);
  };

  this.$get = () => {
    return {
      load: this.load,
      identify: this.identify,
      track: this.track
    };
  };
}

angular
  .module('bringoz.admin')
  .provider('Heap', HeapProvider);
